'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _components = require('components');

var _reactSticky = require('react-sticky');

var _messages = require('redux/modules/messages');

var _Allow = require('../Allow/Allow');

var _Allow2 = _interopRequireDefault(_Allow);

var _Balance = require('../../containers/Reports/Balance');

var _Balance2 = _interopRequireDefault(_Balance);

var _reactBigCalendar = require('react-big-calendar');

var _reactBigCalendar2 = _interopRequireDefault(_reactBigCalendar);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRouter = require('react-router');

var _Messages = require('../Messages/Messages');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _translations = require('translations');

var _translations2 = _interopRequireDefault(_translations);

var _reduxConnect = require('redux-connect');

var _coreDecorators = require('core-decorators');

var _reactRedux = require('react-redux');

var _schedulerTasks = require('redux/modules/schedulerTasks');

var _status = require('redux/modules/status');

var _files = require('redux/modules/files');

var _themeEnabled = require('helpers/themeEnabled');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reachHistory = require('../../helpers/reachHistory');

var _reports = require('redux/modules/reports');

var _sessionPermissions = require('../../helpers/sessionPermissions');

var _Messages2 = require('./Messages.scss');

var _Messages3 = _interopRequireDefault(_Messages2);

var _useBasename = require('../../helpers/useBasename');

var _useBasename2 = _interopRequireDefault(_useBasename);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var md = {
  search: require('react-icons/lib/md/search'),
  expand: require('react-icons/lib/md/open-in-browser'),
  message: require('react-icons/lib/md/email'),
  calendar: require('react-icons/lib/md/date-range'),
  list: require('react-icons/lib/md/list'),
  occurrence: require('react-icons/lib/md/exit-to-app'),
  settings: require('react-icons/lib/md/more-vert'),
  person: require('react-icons/lib/md/person'),
  people: require('react-icons/lib/md/people'),
  tag: require('react-icons/lib/md/label'),
  file: require('react-icons/lib/md/description')
};
var MessagesCalendar = (_dec = (0, _reduxConnect.asyncConnect)([{
  key: 'account',
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var state = getState();
    if (!state.account.data.account_id) {
      return dispatch((0, _status.getAccountStatus)());
    }
    return null;
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    mobileMode: state.mobile.mobileMode,
    accountIsLoading: state.account.loading,
    account: state.status.data
  };
}, {
  getEvents: _messages.getEvents,
  getAgenda: _messages.getAgenda,
  deleteTask: _schedulerTasks.deleteTask,
  getFileStats: _messages.getFileStats,
  getMessageFileDetail: _files.getMessageFileDetail,
  sendTransactionReportLogRequest: _reports.sendTransactionReportLogRequest,
  pushState: _reachHistory.push
}), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  (0, _inherits3.default)(MessagesCalendar, _React$Component);

  function MessagesCalendar(props) {
    (0, _classCallCheck3.default)(this, MessagesCalendar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MessagesCalendar.__proto__ || (0, _getPrototypeOf2.default)(MessagesCalendar)).call(this, props));

    _this.handleFileId = function (task) {
      if (task.event.file_uid && task.type === 'FILE') {
        return task.event.file_uid;
      } else {
        return '';
      }
    };

    _this.getDetailMessage = function (fileId, taskId) {
      var newStats = _this.state.displayStats;
      _this.props.getMessageFileDetail(fileId).then(function (currentStats) {
        currentStats.id = taskId;
        newStats.push(currentStats);
        _this.setState((0, _extends3.default)({}, _this.state, {
          displayStats: newStats
        }));
      }).catch(function (error) {
        return console.error('Error obteniendo stats', error);
      });
    };

    _this.countEvents = function (events) {
      var count = 0;
      (0, _keys2.default)(events).map(function (keyName, i) {
        return count += events[keyName].length;
      });
      return count;
    };

    _this.transformData = function (eventsCalendar) {
      (0, _keys2.default)(_this.state.events).map(function (keyOne) {
        (0, _keys2.default)(_this.state.events[keyOne]).map(function (KeyTwo) {
          _this.state.events[keyOne][KeyTwo].map(function (objeto) {
            var objectCalendar = { color: "#aaa",
              end: new Date(objeto.execution_date),
              start: new Date(objeto.execution_date),
              status: objeto.status,
              title: objeto.task_name,
              taskUid: objeto.task_uid,
              eventId: objeto.event_id };
            eventsCalendar.push(objectCalendar);
          });
        });
      });
    };

    _reactBigCalendar2.default.setLocalizer(_reactBigCalendar2.default.momentLocalizer(_moment2.default));
    var today = new Date();
    _this.state = {
      filtering: false,
      calendar: false,
      display: true,
      option: false,
      showDeleteModal: false,
      startDate: (0, _moment2.default)().startOf('day'),
      agendaStartDate: (0, _moment2.default)().startOf('day'),
      validateAgenda: false,
      endDate: (0, _moment2.default)(_this.props.account && _this.props.account.current_package ? _this.props.account.current_package.valid_thru : (0, _moment2.default)().endOf('month')),
      events: [],
      eventsAgenda: [],
      displayEvents: [],
      displayStats: []
    };
    return _this;
  }

  (0, _createClass3.default)(MessagesCalendar, [{
    key: 'deleteTaskHandler',
    value: function deleteTaskHandler(task, e) {
      var _this2 = this;

      if (task != undefined) {
        //this.props.deleteTask(taskId)
        //const result = this.props.deleteTask(taskId)
        //get the execution_date is the date of the event selected.
        return this.props.deleteTask(task.task_uid, (0, _moment2.default)(task.execution_date).toISOString(), task.event_id).then(function (data) {

          _this2.props.pushState({
            pathname: '/messages/calendar',
            state: {
              modal: false,
              goToModal: false,
              returnTo: '/messages/calendar'
            }
          }).catch(function (e) {
            console.error('Error delete task');
            _this2.setState((0, _extends3.default)({}, _this2.state, {
              notification: e
            }));
          });
        });
      }
    }
  }, {
    key: 'getMessageFileDetailHandler',
    value: function getMessageFileDetailHandler(task) {
      var _this3 = this;

      var fileUid = task.event.file_uid;
      if (fileUid) {
        return this.props.getMessageFileDetail(fileUid).then(function (item) {
          var upload = item.meta.path.substring(item.meta.path.lastIndexOf("/") + 1);
          var fileDetail = [[(0, _translations2.default)('FILE CREATED ON'), (0, _moment2.default)(item.created_on).format('YYYY-MM-DD HH:mm')], [(0, _translations2.default)('CREATED BY'), item.created_by], [(0, _translations2.default)('ROWS FOUND'), item.stats.rows_found], [(0, _translations2.default)('ROWS PROCESSED'), item.stats != undefined ? item.stats.total_messages : 0], [(0, _translations2.default)('ROWS OK'), item.stats != undefined ? item.stats.rows_ok : 0], [(0, _translations2.default)('ROWS DUPLICATED'), item.stats ? item.stats.rows_duplicated : 0], [(0, _translations2.default)('ROWS ERROR'), item.stats ? item.stats.rows_error : 0], [(0, _translations2.default)('FILE STATUS'), (0, _translations2.default)(item.status)]];
          if ((0, _sessionPermissions.sessionPermissions)('transactions:file:scheduled:download')) {
            fileDetail.push([(0, _translations2.default)('DOWNLOAD FILE'), item.meta ? item._id ? item.name : (0, _translations2.default)('FILE NOT FOUND') : (0, _translations2.default)('FILE NOT FOUND'), item.meta ? false : true, (0, _useBasename2.default)() + '/downloads/message-files/' + (item ? item._id ? upload.concat('.csv') : (0, _translations2.default)('FILE NOT FOUND') : null)]);
          }
          if ((0, _sessionPermissions.sessionPermissions)('transactions:file:scheduled:download:report')) {
            fileDetail.push([(0, _translations2.default)('PROCESS FILE'), (0, _translations2.default)('CLICK HERE TO DOWNLOAD ERROR FILE'), item ? item._id ? false : true : true, (0, _useBasename2.default)() + '/downloads/message-files/' + (item ? item._id ? item._id.replace('.csv', '').concat('-cleaned.csv') : null : null)]);
          }
          if ((0, _sessionPermissions.sessionPermissions)('transactions:file:scheduled:download:error')) {
            fileDetail.push([(0, _translations2.default)('ERROR FILE'), (0, _translations2.default)('CLICK HERE TO DOWNLOAD ERROR FILE'), item ? item._id ? false : true : true, (0, _useBasename2.default)() + '/downloads/message-files/' + (item ? item._id ? item._id.replace('.csv', '').concat('-error.csv') : null : null)]);
          }
          _this3.props.pushState({
            pathname: '/messages/calendar/detail',
            state: {
              modal: true,
              modalSize: { width: '830px', height: '600px' },
              returnTo: '/messages/calendar/',
              detail: {
                title: (0, _translations2.default)('MESSAGE FILES'),
                subtitle: (0, _translations2.default)('LOADED ON') + ' ' + (0, _moment2.default)(item.created_on).format('DD/MM'),
                content: item.name,
                Icon: md.file,
                values: fileDetail
              }
            }
          });
        }).catch(function (error) {
          console.error("error en la llamada", error);
        });
      }
    }
  }, {
    key: 'reportFileOrEventHandler',
    value: function reportFileOrEventHandler(task) {
      var _this4 = this;

      var initDate = task.event.execution_date,
          params = {};
      params.scheduler_event_uid = task.event_id;
      return this.props.sendTransactionReportLogRequest(initDate, params).then(function () {
        _this4.props.pushState({
          pathname: '/success',
          state: {
            goTo: 'messages/calendar',
            message: (0, _translations2.default)('REPORT REQUESTED'),
            modal: true,
            returnTo: 'messages/calendar'
          }
        });
      }).catch(function (error) {
        _this4.props.pushState({
          pathname: '/fail',
          state: {
            goTo: 'messages/calendar',
            message: (0, _translations2.default)('DOWNLOAD FILE ERROR'),
            modal: true,
            returnTo: 'messages/calendar'
          }
        });
      });
    }
  }, {
    key: 'callEventsApi',
    value: function callEventsApi(start, end) {
      var _this5 = this;

      var dateFormat = 'YYYY-MM-DD';
      if (start == undefined || start == null) start = this.state.startDate;
      if (end == undefined || end == null) end = this.state.endDate;
      var events = this.props.getAgenda(start.format(dateFormat), end.format(dateFormat));

      events.then(function (data) {
        _this5.setState((0, _extends3.default)({}, _this5.state, {
          events: data,
          displayEvents: []
        }));
      }).catch(function (error) {
        console.error("mensaje de error", error);
      });
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (__CLIENT__) {
        this.callEventsApi();
      }
    }
  }, {
    key: 'handleNavigate',
    value: function handleNavigate(start, interval) {
      try {
        var startDate = start ? (0, _moment2.default)(start).startOf('month').subtract(7, "days") : null;
        var endDate = startDate ? (0, _moment2.default)(start).add(1, interval + 's').add(7, "days") : null;
        this.callEventsApi(startDate, endDate);
      } catch (error) {
        console.error("Error en llamada a API", error);
      }
      var data = [];
      this.transformData(data);
      return data;
    }
  }, {
    key: 'onDateChange',
    value: function onDateChange() {
      var _this6 = this;

      this.setState((0, _extends3.default)({}, this.state, {
        filtering: false
      }), function () {
        _this6.callEventsApi(_this6.state.startDate, _this6.state.endDate);
      });
    }
  }, {
    key: 'handleDateChange',
    value: function handleDateChange(cycle, startDate, endDate) {
      if (startDate && endDate) {
        this.setState((0, _extends3.default)({}, this.state, {
          startDate: startDate,
          endDate: endDate
        }), this.onDateChange);
      } else if (startDate) {
        this.setState((0, _extends3.default)({}, this.state, {
          startDate: startDate
        }), this.onDateChange);
      } else if (endDate) {
        this.setState((0, _extends3.default)({}, this.state, {
          endDate: endDate
        }), this.onDateChange);
      }
    }
  }, {
    key: 'handleFilterToggle',
    value: function handleFilterToggle() {
      if (!this.state.calendar) {
        this.setState((0, _extends3.default)({}, this.state, {
          filtering: !this.state.filtering
        }));
      } else {
        this.setState((0, _extends3.default)({}, this.state));
      }
    }
  }, {
    key: 'handleViewToggle',
    value: function handleViewToggle() {
      this.setState((0, _extends3.default)({}, this.state, {
        calendar: !this.state.calendar
      }));
    }
  }, {
    key: 'handleDisplay',
    value: function handleDisplay() {
      this.setState((0, _extends3.default)({}, this.state, {
        display: !this.state.calendar
      }));
    }
  }, {
    key: 'handleTaskCount',
    value: function handleTaskCount(task) {
      if (task && task.type === 'SINGLE') {
        return task.event.profiles.length;
      } else if (task && task.type === 'TAG') {
        return task.event.tag_names.length;
      } else {
        return 'Contact data not available';
      }
    }
  }, {
    key: 'handleMessageText',
    value: function handleMessageText(task) {
      if (task && task.event) {
        if (task.type !== 'FILE') {
          return task.event.message;
        }
      } else {
        return 'Message data not available';
      }
    }
  }, {
    key: 'handleIcon',
    value: function handleIcon(task) {

      var colorToUse = task.status === 'FINISHED' ? '#747474' : '#1CB176';

      if (task && task.type === 'SINGLE') {
        return _react2.default.createElement(md.people, { size: 25, color: colorToUse });
      } else if (task && task.type === 'FILE') {
        return _react2.default.createElement(md.file, { size: 25, color: colorToUse });
      } else if (task && task.type === 'TAG') {
        return _react2.default.createElement(md.tag, { size: 25, color: colorToUse });
      } else {
        return _react2.default.createElement(md.occurrence, { size: 25, color: colorToUse });
      }
    }
  }, {
    key: 'handleOption',
    value: function handleOption(task, event) {
      var taskId = task.event_id + task.execution_date;
      var newDisplayEvents = this.state.displayEvents;
      var deleted = false;
      var fileId = this.handleFileId(task);
      if ((0, _sessionPermissions.sessionPermissions)('transactions:view')) {
        if (newDisplayEvents) {
          if (newDisplayEvents.length > 0) {
            if (newDisplayEvents.indexOf(taskId) > -1) {
              deleted = true;
            }
          }
        }
        var currentStats = {};
        if (deleted) {
          var temp = newDisplayEvents.filter(function (value) {
            return value != taskId;
          });
          newDisplayEvents = temp;
        } else {
          newDisplayEvents.push(taskId);
          if (fileId !== '') {
            this.getDetailMessage(fileId, taskId);
          }
        }
        this.setState((0, _extends3.default)({}, this.state, {
          displayEvents: newDisplayEvents
        }));
      }
    }
  }, {
    key: 'renderHeader',
    value: function renderHeader() {
      return _react2.default.createElement(_components.GlobalTabs, { activeStyle: { background: '#FFF' } });
    }
  }, {
    key: 'renderNav',
    value: function renderNav(stickyprops) {
      return _react2.default.createElement(
        _components.Nav,
        { key: 'Nav', title: (0, _translations2.default)('MY MESSAGES'), style: stickyprops.style },
        _react2.default.createElement('div', { className: 'search' }),
        _react2.default.createElement(
          'a',
          {
            className: 'action',
            href: '/v5/messages/add',
            onClick: function onClick(e) {
              e.preventDefault();
              window.location.href = '/v5/messages/add';
            }
          },
          (0, _translations2.default)('ADD MESSAGES'),
          _react2.default.createElement(md.message, { size: 20 })
        )
      );
    }
  }, {
    key: 'renderTabs',
    value: function renderTabs() {
      return _react2.default.createElement(_Messages.MessageTabs, null);
    }
  }, {
    key: 'renderFilter',
    value: function renderFilter() {
      if (this.state.filtering && !this.state.calendar) {
        return _react2.default.createElement(_components.ReportFilter, { type: 'AGENDA', startDate: this.state.startDate, endDate: this.state.endDate, onDateChange: this.handleDateChange });
      }
      return null;
    }
  }, {
    key: 'renderTasks',
    value: function renderTasks(tasks) {
      var _this7 = this;

      var result = [];

      tasks.map(function (task) {

        var renderTask = _react2.default.createElement(
          'div',
          { key: task.event_id + task.execution_date },
          _react2.default.createElement(_components.VirtualListItemSchedule, {
            index: task.event_id,
            text: task.task_name,
            icon: _this7.handleIcon(task),
            handleicon: _react2.default.createElement(md.settings, { size: 25, color: '#747474' }),
            mobileMode: false,
            onClick: _this7.handleOption.bind(_this7, task),
            display: true,
            hour: task.execution_date
          }),
          _react2.default.createElement(_components.VirtualListItemCalendarOption, {
            count: _this7.handleTaskCount(task),
            display: _this7.state.displayEvents.find(function (element) {
              return element === task.event_id + task.execution_date;
            }) == undefined ? false : true,
            text: _this7.handleMessageText(task),
            color: '#000',
            show: false,
            state: _this7.state,
            type: task.type,
            status: task.status,
            endDate: task.end_date ? task.end_date : null,
            executionDate: task.execution_date,
            fileId: _this7.handleFileId(task),
            stats: _this7.state.displayStats.find(function (element) {
              return element.id === task.event_id + task.execution_date;
            }),
            deleteTaskHandler: _this7.deleteTaskHandler.bind(_this7, task),
            getMessageFileDetailHandler: (0, _sessionPermissions.sessionPermissions)('transactions:file:scheduled:detail') ? _this7.getMessageFileDetailHandler.bind(_this7, task) : null,
            reportFileOrEventHandler: _this7.reportFileOrEventHandler.bind(_this7, task),
            index: task.task_uid,
            name: task.task_name,
            frequency: task.recurrence && task.recurrence.term ? (0, _translations2.default)(task.recurrence.term) : (0, _translations2.default)('PAST EVENT')
          })
        );
        result.push(renderTask);
      });

      return _react2.default.createElement(
        'div',
        { className: _Messages3.default.taskShow },
        result.map(function (item, index) {
          return _react2.default.createElement(
            'div',
            { key: tasks[0].task_uid + tasks[0].execution_date + index },
            item,
            ' '
          );
        })
      );
    }
  }, {
    key: 'renderHours',
    value: function renderHours(hours) {
      var _this8 = this;

      return _react2.default.createElement(
        'div',
        { className: _Messages3.default.rowHolder },
        _react2.default.createElement(
          'div',
          { className: _Messages3.default.hourShow },
          (0, _keys2.default)(hours).map(function (keyName, i) {
            return _this8.renderTasks(hours[keyName]);
          })
        )
      );
    }
  }, {
    key: 'renderDays',
    value: function renderDays(days) {
      var _this9 = this;

      var events = this.state.events;
      return _react2.default.createElement(
        'div',
        { className: _Messages3.default.allDays },
        ' ',
        days.map(function (dayKey) {
          return _react2.default.createElement(
            'div',
            { className: _Messages3.default.individualDay },
            _react2.default.createElement(
              'div',
              { className: _Messages3.default.topHeader },
              _react2.default.createElement(
                'div',
                { className: _Messages3.default.dateHeader },
                (0, _moment2.default)(dayKey).locale('es').format('dddd, D MMMM YYYY')
              ),
              _react2.default.createElement(
                'div',
                { className: _Messages3.default.occurrencesCounter },
                _react2.default.createElement(md.occurrence, { size: 20, color: '#616161', className: _Messages3.default.occurrenceIcon }),
                '  ',
                (0, _translations2.default)('OCCURRENCES'),
                ': \xA0',
                _this9.countEvents(events[dayKey])
              )
            ),
            _react2.default.createElement(
              'div',
              { className: _Messages3.default.daysShow },
              _this9.renderHours(events[dayKey])
            )
          );
        })
      );
    }
  }, {
    key: 'renderAgenda',
    value: function renderAgenda() {
      var events = this.state.events;
      var days = [];
      (0, _keys2.default)(events).sort().forEach(function (eventKey) {
        days.push(eventKey);
      });
      return this.renderDays(days);
    }
  }, {
    key: 'showEventHandler',
    value: function showEventHandler() {}
  }, {
    key: 'renderMain',
    value: function renderMain() {
      var _this10 = this;

      if (this.state.calendar) {
        var eventsCalendar = [];
        if (this.state.agendaStartDate.format('YYYY-MM-DD') == (0, _moment2.default)().startOf('day').format('YYYY-MM-DD') && !this.state.validateAgenda) {
          this.callEventsApi((0, _moment2.default)().startOf('month').subtract(7, "days"), (0, _moment2.default)().endOf('month').add(7, "days"));
          this.setState({ agendaStartDate: (0, _moment2.default)().startOf('month'), validateAgenda: !this.state.validateAgenda });
        }
        this.transformData(eventsCalendar);
        return _react2.default.createElement(
          'div',
          { className: _Messages3.default.bigcalendar },
          _react2.default.createElement(_reactBigCalendar2.default, (0, _extends3.default)({}, this.props, {
            culture: 'es-GT',
            events: eventsCalendar,
            onNavigate: this.handleNavigate.bind(this),
            onSelectEvent: function onSelectEvent(event) {
              _this10.props.pushState({
                pathname: '/message/scheduled',
                state: {
                  modal: true,
                  returnTo: '/messages/calendar',
                  detail: event
                }
              });
            },
            defaultDate: (0, _moment2.default)().startOf('month').toDate(),
            views: ['month', 'day'],
            messages: {
              today: (0, _translations2.default)('TODAY'),
              previous: (0, _translations2.default)('PREVIOUS'),
              next: (0, _translations2.default)('NEXT'),
              month: (0, _translations2.default)('MONTH'),
              week: (0, _translations2.default)('WEEK'),
              day: (0, _translations2.default)('DAY'),
              agenda: (0, _translations2.default)('AGENDA')
            }
          }))
        );
      }
      if (this.state.agendaStartDate.format('YYYY-MM-DD') !== (0, _moment2.default)().startOf('day').format('YYYY-MM-DD')) {
        this.callEventsApi(this.state.startDate, this.state.endDate);
        this.setState({ agendaStartDate: (0, _moment2.default)().startOf('day'), validateAgenda: !this.state.validateAgenda });
      }

      if (this.state.events !== undefined && (0, _keys2.default)(this.state.events).length > 0) {
        return this.renderAgenda();
      }
      var visible = { display: 'block' };
      var linkstyle = visible;
      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          'a',
          {
            href: '/v5/messages/add',
            onClick: function onClick(e) {
              e.preventDefault();
              window.location.href = '/v5/messages/add';
            },
            className: _Messages3.default.emptyStateLink
          },
          _react2.default.createElement(
            'h1',
            { className: _Messages3.default.emptyStateText },
            (0, _translations2.default)('NO MESSAGES FOUND CALENDAR')
          ),
          _react2.default.createElement(
            'button',
            { className: _Messages3.default.emptyStateButton },
            (0, _translations2.default)('SEND A NEW MESSAGE')
          )
        )
      );
    }
  }, {
    key: 'renderRight',
    value: function renderRight() {
      return _react2.default.createElement('div', null);
    }
  }, {
    key: 'renderCalendarButton',
    value: function renderCalendarButton() {
      return _react2.default.createElement(
        'div',
        { className: _Messages3.default.innerContainer },
        _react2.default.createElement(
          'div',
          { className: _Messages3.default.inactiveAgenda },
          _react2.default.createElement(md.list, { size: 20 }),
          ' ',
          (0, _translations2.default)('AGENDA')
        ),
        _react2.default.createElement(
          'div',
          { className: _Messages3.default.activeCalendar },
          _react2.default.createElement(md.calendar, { color: 'white', size: 20 }),
          ' ',
          (0, _translations2.default)('CALENDAR')
        )
      );
    }
  }, {
    key: 'renderAgendaButton',
    value: function renderAgendaButton() {
      return _react2.default.createElement(
        'div',
        { className: _Messages3.default.innerContainer },
        _react2.default.createElement(
          'div',
          { className: _Messages3.default.activeAgenda },
          _react2.default.createElement(md.list, { color: 'white', size: 20 }),
          ' ',
          (0, _translations2.default)('AGENDA')
        ),
        _react2.default.createElement(
          'div',
          { className: _Messages3.default.inactiveAgenda },
          _react2.default.createElement(md.calendar, { size: 20 }),
          ' ',
          (0, _translations2.default)('CALENDAR')
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var start = this.state.startDate.locale('es').format('MMM D');
      var end = this.state.endDate.locale('es').format('MMM D');
      var classesTheme = (0, _themeEnabled.getThemeEnabledStyle)(_Messages3.default);
      return _react2.default.createElement(
        'div',
        { className: classesTheme },
        _react2.default.createElement(
          'div',
          { className: _Messages3.default.messageContainer },
          _react2.default.createElement(_reactHelmet2.default, { title: 'Mensajes Programados' }),
          this.renderFilter(),
          _react2.default.createElement(
            'div',
            { className: _Messages3.default.topBarContainer },
            _react2.default.createElement(
              'button',
              { className: _Messages3.default.filterButton, onClick: this.handleFilterToggle },
              this.state.filtering ? _react2.default.createElement(md.expand, { className: _Messages3.default.icon, size: 25, color: '#FFF' }) : _react2.default.createElement(md.search, { className: _Messages3.default.icon, size: 25, color: '#FFF' }),
              this.state.calendar ? (0, _translations2.default)('CALENDAR') : 'Agenda: ' + start + ' - ' + end
            ),
            _react2.default.createElement(
              'button',
              { className: _Messages3.default.outerButton, onClick: this.handleViewToggle },
              this.state.calendar ? this.renderCalendarButton() : this.renderAgendaButton()
            )
          ),
          this.renderMain()
        )
      );
    }
  }]);
  return MessagesCalendar;
}(_react2.default.Component), _class3.propTypes = {
  mobileMode: _propTypes2.default.bool,
  events: _propTypes2.default.array,
  getEvents: _propTypes2.default.func.isRequired,
  getFileStats: _propTypes2.default.func.isRequired
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'deleteTaskHandler', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deleteTaskHandler'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'getMessageFileDetailHandler', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'getMessageFileDetailHandler'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'reportFileOrEventHandler', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'reportFileOrEventHandler'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'callEventsApi', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'callEventsApi'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleDateChange', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleDateChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleFilterToggle', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleFilterToggle'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleViewToggle', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleViewToggle'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleDisplay', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleDisplay'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleTaskCount', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleTaskCount'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleMessageText', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleMessageText'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleOption', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleOption'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'renderAgenda', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'renderAgenda'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showEventHandler', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'showEventHandler'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = MessagesCalendar;
module.exports = exports['default'];